import { requestGet } from '@/common/request';

export interface DataOfList {
  totalPage: number;
  pageSize: number;
  currentPage: number;
  totalCount: number;
  list: {
    id: number;
    code: string;
    name: string;
    skuNum: string;
    source: string;
    btn: ('update' | 'download' | 'del')[];
  }[];
}

// 活动盘品-获取促销选品配置信息
export default async function goodsGroupList(query: {
  currentPage: number;
  pageSize: number;
  simpleQUery?: boolean;
}): Promise<RequestResult> {
  return await requestGet('/goodsGroup/list', query);
}
